import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
    name: 'gxDate'
})
export class GxDatePipe implements PipeTransform {

    constructor() { }

    transform(value: string, shortHandFormat: string): string {
        value = value || '';
        const formats = {
            'time': 'h:mm A', //(e.g. 9:05 PM)
            'date': 'ddd, D MMM YYYY', //(e.g. Fri, 3 Sep 2010) ...old 'long'
            'default': 'ddd, D MMM YYYY h:mm A', //e.g. Thu, 20 Oct 2016 09:00 AM
            'shortdate': 'YYYY-MM-DD' };
        let chosenFormat = formats[shortHandFormat];
        if (!chosenFormat) {
            chosenFormat = shortHandFormat;
        }

        const output = moment(value).format(chosenFormat);
        return output;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/gx-date.pipe.ts